import { Box, Chip, Typography } from '@mui/material';
import React from 'react';
import Investor from '../../../models/Investor';
import {
  eoiStatusColor,
  eoiStatusLabel,
  fmtCurrency,
  getInvestorFundId,
} from './contactOpportunitiesUtils';

export default function EoiCard({
  investor,
  navigate,
}: {
  investor: Investor;
  navigate: (path: string) => void;
}) {
  const fund = investor.fundOpportunity as { name?: string } | undefined;
  const fundName = fund?.name ?? 'Unknown Fund';
  const fundId = getInvestorFundId(investor);
  const amount = investor.preferredInvestment ?? investor.indicativeInvestment;

  return (
    <Box
      onClick={(e) => {
        e.stopPropagation();
        if (fundId && investor.id) {
          navigate(`/opportunities/${fundId}/investors/${investor.id}?tab=eoi`);
        }
      }}
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1.5,
        p: 1.75,
        bgcolor: 'background.paper',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: 2,
        cursor: fundId ? 'pointer' : 'default',
        '&:hover': fundId ? { bgcolor: 'action.hover' } : {},
        transition: 'background-color 0.15s',
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="subtitle2" noWrap title={fundName}>
          {fundName}
        </Typography>
        {amount != null && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
            {fmtCurrency(amount)} indicative
          </Typography>
        )}
        {investor.eoiSubmittedOn && (
          <Typography variant="caption" color="text.disabled">
            EOI submitted{' '}
            {new Date(investor.eoiSubmittedOn).toLocaleDateString('en-AU', {
              day: 'numeric',
              month: 'short',
              year: 'numeric',
            })}
          </Typography>
        )}
      </Box>
      <Chip
        label={eoiStatusLabel(investor.status)}
        color={eoiStatusColor(investor.status)}
        size="small"
        sx={{ flexShrink: 0 }}
      />
    </Box>
  );
}
